import { rei } from "@/services/api"
import PapelSegurancaLoteItem from "../../entities/papelSeguranca/PapelSegurancaLoteItem"

/* libraries */
import moment from "moment"
import store from "@/store"

class PapelSegurancaLoteItensService {
  static getItensByLote (data) {
    const { lote_id, page, perPage } = data

    const config = {
      params: {
        ...data
      }
    }

    return rei.get(`papel-seguranca/itens-lote/${ lote_id }`, config).then(res => res.data)
  }

  static cancelItem (item) {
    const user = store.getters['auth/getUser']

    const payload = {
      ...item,
      status: PapelSegurancaLoteItensService.CANCELADO,
      data_cancelamento: moment().format('YYYY-MM-DD HH:mm:ss'),
      usuario_id: user.user_id,
      registro_id: null,
      data_consumo: null,
      tipo_uso: null
    }

    delete payload.created_at
    delete payload.updated_at

    const { papel_seguranca_lote_item_id } = item

    return rei.put(`papel-seguranca/itens/${ papel_seguranca_lote_item_id }`, payload).then(res => res.data)
  }

  static reuseItem (item) {
    const payload = {
      ...item,
      status: PapelSegurancaLoteItensService.ATIVO,
      data_cancelamento: null,
      motivo_cancelamento: null,
      usuario_id: null,
      registro_id: null,
      data_consumo: null,
      tipo_uso: null
    }

    delete payload.created_at
    delete payload.updated_at

    const { papel_seguranca_lote_item_id } = item

    return rei.put(`papel-seguranca/itens/${ papel_seguranca_lote_item_id }`, payload).then(res => res.data)
  }

  static async getItensAtivos (tipoPapel) {
    const data = await rei.get(`papel-seguranca/itens?status=${ PapelSegurancaLoteItensService.ATIVO }&tipo=${tipoPapel}&perPage=10`).then(res => res.data)
    data.data = data.data.map((papel) => new PapelSegurancaLoteItem(papel))
    return data
  }

  static consume (payload) {
    return rei.post(`papel-seguranca/consumir`, payload).then(res => res.data)
  }

  static consumeSelo (papelSeguranca, item, tipoPapel) {
    const user = store.getters['auth/getUser']
    const payload = {
      ...papelSeguranca,
      numero_serie: papelSeguranca.numero_serie && papelSeguranca.numero_serie.toUpperCase() || null,
      ordem_servico_id: item.ordem_servico_id,
      usuario_id: user.user_id,
      tipo_uso: PapelSegurancaLoteItensService.OS,
      data_consumo: moment().format('YYYY-MM-DD HH:mm:ss'),
      tipo_papel: tipoPapel
    }

    return rei.post(`papel-seguranca/consumir`, payload).then(res => res.data)
  }
}

PapelSegurancaLoteItensService.ATIVO = 'ATIVO'
PapelSegurancaLoteItensService.USADO = 'USADO'
PapelSegurancaLoteItensService.CANCELADO = 'CANCELADO'
PapelSegurancaLoteItensService.PRIMEIRA = 'PRIMEIRA'
PapelSegurancaLoteItensService.SEGUNDA = 'SEGUNDA'
PapelSegurancaLoteItensService.OS = 'OS'

export default PapelSegurancaLoteItensService
